import React, { useEffect, useState } from 'react';
import { useAuth } from 'nursd-dashboard/context/AuthContext';
import { Card, Col, Form, Row } from 'react-bootstrap';
import IconButton from 'components/common/IconButton';
// import { Link } from 'react-router-dom';
// import paths from 'routes/paths';
import TemplateTable from './table/TemplateTable';
import moment from 'moment';
import { getAllLocationTemplate } from 'nursd-dashboard/api/jobTemplate';
import { Link } from 'react-router-dom';
import paths from 'routes/paths';
import Update_Template from './update_template';

const Template = () => {
  const [options] = useState(['Both', 'Shift', 'Visit']);

  const [templates, setTemplates] = useState([]);
  const [downloadData, setDownloadData] = useState([]);
  const [loadingScreen, setLoadingScreen] = useState(true);
  const [type, setType] = useState('Both');
  const [searchText, setSearchText] = useState('');
  const [show, setShow] = useState(false);
  const [data, setData] = useState(undefined);
  const [refresh, setRefresh] = useState(false);

  const { authToken, location, organization } = useAuth();

  const getTemplate = async type => {
    setLoadingScreen(true);
    try {
      const temList = await getAllLocationTemplate(
        authToken,
        type,
        location,
        organization
      );
      // console.log(temList);
      const list = temList;
      let array = [];
      for (let i = 0; i < list.length; i++) {
        const item = list[i];
        let obj = {
          id: item.id,
          templateName: item.jobTemplateName,
          licenseType: item.licenseType,
          title: item.shiftTitle,
          jobType: item.jobType,
          startDate: moment(item.startDate).format('MM-DD-YYYY'),
          endDate: moment(item.endDate).format('MM-DD-YYYY'),
          startTime: moment(item.startTime).format('hh:mm a'),
          endTime: moment(item.endTime).format('hh:mm a'),
          break: item.break,
          customerName: item.customerName,
          unit: item.unit,
          floor: item.floor,
          fullAddress: item.fullAddress,
          notes: item.notes,
          customerVisibility: item.customerVisibility ? 'Yes' : 'No',
          templateType: item.additionalFields[0]?.templateType,
          createdAt: item.createdAt,
          original: item
        };
        array.push(obj);
      }

      let arrayDownload = [];

      for (let i = 0; i < list?.length; i++) {
        const item = list[i];
        let obj = {
          TemplateName: item.jobTemplateName,
          LicenseType: item.licenseType,
          Title: item.shiftTitle,
          JobType: item.jobType,
          StartDate: moment(item.startDate).format('MM-DD-YYYY'),
          EndDate: moment(item.endDate).format('MM-DD-YYYY'),
          StartTime: moment(item.startTime).format('hh:mm a'),
          EndTime: moment(item.endTime).format('hh:mm a'),
          Break: item.break,
          CustomerName: item.customerName,
          Unit: item.unit,
          Floor: item.floor,
          FullAddress: item.fullAddress,
          Notes: item.notes,
          CustomerVisibility: item.customerVisibility ? 'Yes' : 'No',
          TemplateType: item.additionalFields[0]?.templateType
        };
        arrayDownload.push(obj);
      }

      if (
        list.length === array.length &&
        list.length === arrayDownload.length
      ) {
        // console.log(array);
        setTemplates(array);
        setDownloadData(arrayDownload);
        setLoadingScreen(false);
      }
    } catch (error) {
      setTemplates([]);
      setDownloadData([]);
      setLoadingScreen(false);
    }
  };

  useEffect(() => {
    if (location !== '') {
      getTemplate(type);
    }
  }, [authToken, location, type, refresh]);

  const filter = data => {
    return data?.filter(item =>
      item?.templateName?.toLowerCase().includes(searchText?.toLowerCase())
    );
  };

  function convertToCSV(jsonData) {
    const separator = ',';
    const keys = Object.keys(jsonData[0]);
    const csvContent = [
      keys.join(separator),
      ...jsonData.map(item => {
        // Extract the 'FullAddress' and 'LicenseType' properties
        const { FullAddress, LicenseType, ...rest } = item;

        // Join the values of the other properties with the 'FullAddress' and 'LicenseType' values
        const values = keys.map(key =>
          key === 'FullAddress'
            ? `"${FullAddress}"`
            : key === 'LicenseType'
            ? `"${LicenseType.join(', ')}"`
            : rest[key]
        );

        return values.join(separator);
      })
    ].join('\n');

    return csvContent;
  }

  const downloadCSVFile = data => {
    let current = moment().format('MM-DD-YYYY');
    // Create a Blob object for the CSV data
    const blob = new Blob([data], { type: 'text/csv' });

    // Create a temporary URL for the Blob
    const url = URL.createObjectURL(blob);

    // Create a link element
    const link = document.createElement('a');
    link.href = url;
    link.download = `${location}-Template-${current}.csv`;

    // Trigger the download
    link.click();

    // Clean up the temporary URL
    URL.revokeObjectURL(url);
  };

  return (
    <>
      {!show ? (
        <Card>
          <Card.Header className="bg-body-tertiary">
            <Row className="align-items-center g-1">
              <Col className="pe-0">
                <Row className="g-2">
                  <Col>
                    <h5 className="mb-0 text-secondary">
                      Template Records : {filter(templates)?.length}
                    </h5>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className="g-2 mt-2">
              <Col sm={2}>
                <Form.Control
                  placeholder="Search by name..."
                  onChange={e => setSearchText(e.target.value)}
                  size="sm"
                />
              </Col>
              <Col sm={2}>
                <Form.Select
                  onChange={e => setType(e.target.value)}
                  size="sm"
                  value={type}
                >
                  {options.map(option => (
                    <option key={option}>{option}</option>
                  ))}
                </Form.Select>
              </Col>
              <Col xs="auto" className="d-flex order-md-0">
                {/* <IconButton
                  variant="success"
                  iconClassName="me-2"
                  icon="plus"
                  size="sm"
                >
                  <Link to={paths.nursd_nurse_upload}>
                    <span className="text-light ms-1">Upload CSV</span>
                  </Link>
                </IconButton> */}
                <Link to={paths.nursd_template_form}>
                  <IconButton
                    variant="falcon-default"
                    size="sm"
                    icon="plus"
                    transform="shrink-3"
                    className="mx-2"
                  >
                    <span className="d-none text-dark d-sm-inline-block ms-1">
                      New
                    </span>
                  </IconButton>
                </Link>
                <IconButton
                  variant="falcon-default"
                  size="sm"
                  icon="external-link-alt"
                  transform="shrink-3"
                  onClick={() => downloadCSVFile(convertToCSV(downloadData))}
                >
                  <span className="d-none d-sm-inline-block ms-1">Export</span>
                </IconButton>
              </Col>
            </Row>
          </Card.Header>
          {location === '' ? (
            <div className="m-3">
              <p>Select Location Id</p>
            </div>
          ) : loadingScreen ? (
            <div className="m-3">
              <p>Loading...</p>
            </div>
          ) : templates?.length === 0 ? (
            <div className="m-3">
              <p>{location} - No Data Available</p>
            </div>
          ) : (
            <Card.Body className="bg-body-tertiary px-1 pb-1 pt-0 fs-10">
              <TemplateTable
                data={filter(templates)}
                setShow={setShow}
                setData={setData}
              />
            </Card.Body>
          )}
        </Card>
      ) : (
        <Card>
          <Card.Header className="bg-body-tertiary">
            <h5>Update Template</h5>
          </Card.Header>
          <Update_Template
            data={data}
            setShow={setShow}
            setData={setData}
            refresh={refresh}
            setRefresh={setRefresh}
          />
        </Card>
      )}
    </>
  );
};

Template.propTypes = {};

export default Template;
